import { render, staticRenderFns } from "./AdjustmentsCutOff.vue?vue&type=template&id=2a27833e"
import script from "./AdjustmentsCutOff.vue?vue&type=script&lang=js"
export * from "./AdjustmentsCutOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports